import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleLayout from '@/components/feature/ArticleLayout';
import { articles } from '@/mocks/articles';

const relatedArticles = [
  { id: 'how-to-use-litbuy-spreadsheet', title: 'How to Use a LitBuy Spreadsheet Effectively' },
  { id: 'litbuy-spreadsheet-tips', title: 'LitBuy Spreadsheet Tips and Tricks' },
  { id: 'build-litbuy-spreadsheet', title: 'How to Build Your Own LitBuy Spreadsheet' },
];

export default function WorkflowPage() {
  return (
    <main>
      <Navbar />
      <ArticleLayout article={articles['litbuy-spreadsheet-workflow']} relatedArticles={relatedArticles} />
      <Footer />
    </main>
  );
}